import { render } from "./WhatWeDo.vue?vue&type=template&id=7f04d166&scoped=true&ts=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=ts"
export * from "./WhatWeDo.vue?vue&type=script&lang=ts"

import "./WhatWeDo.vue?vue&type=style&index=0&id=7f04d166&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f04d166"]])

export default __exports__